<template>
  <el-dialog
    v-if="isShow"
    title="Edit Carrier Service Setting"
    :visible.sync="isShow"
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
  >
    <CarrierServiceSettingEditForm
      ref="editForm"
      v-model="carrierServiceSetting"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="updateCarrierServiceSetting()"
      >
        Update
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CarrierServiceSettingEditForm from '@/components/Application/Manage/Account/CarrierServiceSettingEditForm'
export default {
  components: {
    CarrierServiceSettingEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isShow: false,
      isFullscreen: false,
      isSaving: false,
      carrierServiceSetting: {}
    }
  },
  methods: {
    updateCarrierServiceSetting () {
      this.$refs.editForm.$refs.carrierServiceSettingForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.carrierServiceSetting.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['carrier_service', 'carrier_type', 'service_rate_type']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
